// extracted by mini-css-extract-plugin
export default {"mainHeader":"style_mainHeader__qZ8Er","pageTitle":"style_pageTitle__RkcE5"};